export default function Footer() {
  return (
    <footer className="mt-16 border-t border-white/10 bg-slate-950/70">
      <div className="container py-10 text-center text-sm text-slate-300">
        Developed by <span className="text-slate-100">Nirmal Chaudhari</span>{' '}
        · Aug 2023
      </div>
    </footer>
  );
}


